/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getDeveloperApiTokens } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetDeveloperApiTokens(filters: any) {
  return useQuery({
    queryKey: userQueryKeys.developerApiTokens(filters),
    queryFn: () => getDeveloperApiTokens({ params: filters }).then((res) => res.data),
  });
}
